export const HomechainOmnichainMessengerAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: '_stargateComposer', internalType: 'address', type: 'address' },
      { name: '_endpoint', internalType: 'address payable', type: 'address' },
      { name: '_eid', internalType: 'uint16', type: 'uint16' },
      { name: '_sgETH', internalType: 'address', type: 'address' },
      {
        name: '_nativeInfo',
        internalType: 'struct OmnichainMessenger.NativeInfo',
        type: 'tuple',
        components: [
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'symbol', internalType: 'string', type: 'string' },
          { name: 'decimals', internalType: 'uint8', type: 'uint8' },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'receive', stateMutability: 'payable' },
  {
    type: 'function',
    inputs: [
      { name: 'chainIds', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'chainIdSet', internalType: 'uint256[]', type: 'uint256[]' },
      {
        name: 'homechainOrders',
        internalType: 'struct RebalancingLib.ChainOrders',
        type: 'tuple',
        components: [
          {
            name: 'orders',
            internalType: 'struct OrderLib.Order[]',
            type: 'tuple[]',
            components: [
              { name: 'sellAmount', internalType: 'uint96', type: 'uint96' },
              {
                name: 'idParams',
                internalType: 'struct OrderLib.OrderId',
                type: 'tuple',
                components: [
                  {
                    name: 'sellCurrency',
                    internalType: 'Currency',
                    type: 'address',
                  },
                  {
                    name: 'localBuyCurrency',
                    internalType: 'Currency',
                    type: 'address',
                  },
                  {
                    name: 'finalDestinationBuyCurrency',
                    internalType: 'Currency',
                    type: 'address',
                  },
                  {
                    name: 'finalDestinationChainId',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                ],
              },
            ],
          },
          { name: 'incomingOrders', internalType: 'uint128', type: 'uint128' },
        ],
      },
      { name: 'ordersHashes', internalType: 'bytes32[]', type: 'bytes32[]' },
      {
        name: 'withdrawals',
        internalType: 'struct IVault.CurrencyWithdrawal[]',
        type: 'tuple[]',
        components: [
          {
            name: 'currencyIndexSet',
            internalType: 'uint256[]',
            type: 'uint256[]',
          },
          { name: 'amounts', internalType: 'uint96[]', type: 'uint96[]' },
        ],
      },
      { name: 'lzData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'broadcastOrders',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'chainIds', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'chainIdSet', internalType: 'uint256[]', type: 'uint256[]' },
      {
        name: 'chainOrders',
        internalType: 'struct RebalancingLib.ChainOrders[]',
        type: 'tuple[]',
        components: [
          {
            name: 'orders',
            internalType: 'struct OrderLib.Order[]',
            type: 'tuple[]',
            components: [
              { name: 'sellAmount', internalType: 'uint96', type: 'uint96' },
              {
                name: 'idParams',
                internalType: 'struct OrderLib.OrderId',
                type: 'tuple',
                components: [
                  {
                    name: 'sellCurrency',
                    internalType: 'Currency',
                    type: 'address',
                  },
                  {
                    name: 'localBuyCurrency',
                    internalType: 'Currency',
                    type: 'address',
                  },
                  {
                    name: 'finalDestinationBuyCurrency',
                    internalType: 'Currency',
                    type: 'address',
                  },
                  {
                    name: 'finalDestinationChainId',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                ],
              },
            ],
          },
          { name: 'incomingOrders', internalType: 'uint128', type: 'uint128' },
        ],
      },
      { name: 'lzParams', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'broadcastReserveOrders',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_index', internalType: 'address', type: 'address' },
      { name: '_orderBook', internalType: 'address', type: 'address' },
      { name: '_builder', internalType: 'address', type: 'address' },
    ],
    name: 'configure',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'result',
        internalType: 'struct IVault.RegisterCurrenciesResult',
        type: 'tuple',
        components: [
          { name: 'currencies', internalType: 'Currency[]', type: 'address[]' },
          { name: 'currenciesHash', internalType: 'bytes32', type: 'bytes32' },
        ],
      },
    ],
    name: 'currenciesUpdated',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'currency', internalType: 'Currency', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      {
        name: 'params',
        internalType: 'struct IIndex.DepositParams',
        type: 'tuple',
        components: [
          {
            name: 'config',
            internalType: 'struct IIndex.DepositConfig',
            type: 'tuple',
            components: [
              {
                name: 'shared',
                internalType: 'struct IIndex.Config',
                type: 'tuple',
                components: [
                  {
                    name: 'latestSnapshot',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'AUMDilutionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'useCustomAUMFee',
                    internalType: 'bool',
                    type: 'bool',
                  },
                  {
                    name: 'staticPriceOracle',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'metadata',
                    internalType: 'address',
                    type: 'address',
                  },
                ],
              },
              {
                name: 'fee',
                internalType: 'struct IIndex.FeeConfig',
                type: 'tuple',
                components: [
                  { name: 'BPs', internalType: 'uint16', type: 'uint16' },
                  {
                    name: 'useCustomCallback',
                    internalType: 'bool',
                    type: 'bool',
                  },
                ],
              },
            ],
          },
          { name: 'recipient', internalType: 'address', type: 'address' },
          { name: 'payload', internalType: 'bytes', type: 'bytes' },
        ],
      },
    ],
    name: 'deposit',
    outputs: [{ name: 'shares', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'currency', internalType: 'Currency', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      {
        name: 'params',
        internalType: 'struct IIndex.DepositParams',
        type: 'tuple',
        components: [
          {
            name: 'config',
            internalType: 'struct IIndex.DepositConfig',
            type: 'tuple',
            components: [
              {
                name: 'shared',
                internalType: 'struct IIndex.Config',
                type: 'tuple',
                components: [
                  {
                    name: 'latestSnapshot',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'AUMDilutionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'useCustomAUMFee',
                    internalType: 'bool',
                    type: 'bool',
                  },
                  {
                    name: 'staticPriceOracle',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'metadata',
                    internalType: 'address',
                    type: 'address',
                  },
                ],
              },
              {
                name: 'fee',
                internalType: 'struct IIndex.FeeConfig',
                type: 'tuple',
                components: [
                  { name: 'BPs', internalType: 'uint16', type: 'uint16' },
                  {
                    name: 'useCustomCallback',
                    internalType: 'bool',
                    type: 'bool',
                  },
                ],
              },
            ],
          },
          { name: 'recipient', internalType: 'address', type: 'address' },
          { name: 'payload', internalType: 'bytes', type: 'bytes' },
        ],
      },
      { name: 'permitData', internalType: 'bytes', type: 'bytes' },
      { name: 'tradeData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'depositAndTradeWithPermit',
    outputs: [{ name: 'shares', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'currency', internalType: 'Currency', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      {
        name: 'params',
        internalType: 'struct IIndex.DepositParams',
        type: 'tuple',
        components: [
          {
            name: 'config',
            internalType: 'struct IIndex.DepositConfig',
            type: 'tuple',
            components: [
              {
                name: 'shared',
                internalType: 'struct IIndex.Config',
                type: 'tuple',
                components: [
                  {
                    name: 'latestSnapshot',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'AUMDilutionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'useCustomAUMFee',
                    internalType: 'bool',
                    type: 'bool',
                  },
                  {
                    name: 'staticPriceOracle',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'metadata',
                    internalType: 'address',
                    type: 'address',
                  },
                ],
              },
              {
                name: 'fee',
                internalType: 'struct IIndex.FeeConfig',
                type: 'tuple',
                components: [
                  { name: 'BPs', internalType: 'uint16', type: 'uint16' },
                  {
                    name: 'useCustomCallback',
                    internalType: 'bool',
                    type: 'bool',
                  },
                ],
              },
            ],
          },
          { name: 'recipient', internalType: 'address', type: 'address' },
          { name: 'payload', internalType: 'bytes', type: 'bytes' },
        ],
      },
      { name: 'permitData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'depositWithPermit',
    outputs: [{ name: 'shares', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'eIds',
    outputs: [{ name: '', internalType: 'uint16', type: 'uint16' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'orderBookParams',
        internalType: 'struct IOrderBook.FinishOrderExecutionParams',
        type: 'tuple',
        components: [
          {
            name: 'orderIds',
            internalType: 'struct OrderLib.OrderId[]',
            type: 'tuple[]',
            components: [
              {
                name: 'sellCurrency',
                internalType: 'Currency',
                type: 'address',
              },
              {
                name: 'localBuyCurrency',
                internalType: 'Currency',
                type: 'address',
              },
              {
                name: 'finalDestinationBuyCurrency',
                internalType: 'Currency',
                type: 'address',
              },
              {
                name: 'finalDestinationChainId',
                internalType: 'uint256',
                type: 'uint256',
              },
            ],
          },
          { name: 'idIndices', internalType: 'uint256[]', type: 'uint256[]' },
          {
            name: 'pendingOrderCounts',
            internalType: 'uint256[]',
            type: 'uint256[]',
          },
        ],
      },
      {
        name: 'params',
        internalType: 'struct IVault.EndRebalancingParams',
        type: 'tuple',
        components: [
          {
            name: 'anatomyCurrencies',
            internalType: 'a160u96[]',
            type: 'uint256[]',
          },
          {
            name: 'newAnatomy',
            internalType: 'struct IVault.SnapshotAnatomy',
            type: 'tuple',
            components: [
              {
                name: 'currencies',
                internalType: 'a160u96[]',
                type: 'uint256[]',
              },
              {
                name: 'currencyIndexSet',
                internalType: 'uint256[]',
                type: 'uint256[]',
              },
            ],
          },
          {
            name: 'withdrawals',
            internalType: 'struct IVault.CurrencyWithdrawal',
            type: 'tuple',
            components: [
              {
                name: 'currencyIndexSet',
                internalType: 'uint256[]',
                type: 'uint256[]',
              },
              { name: 'amounts', internalType: 'uint96[]', type: 'uint96[]' },
            ],
          },
          { name: 'lastKBalance', internalType: 'uint256', type: 'uint256' },
          { name: 'currencies', internalType: 'Currency[]', type: 'address[]' },
        ],
      },
      {
        name: 'sgParams',
        internalType: 'struct IOmnichainMessenger.SgParams[]',
        type: 'tuple[]',
        components: [
          {
            name: 'lzTxObj',
            internalType: 'struct IStargateRouter.lzTxObj',
            type: 'tuple',
            components: [
              {
                name: 'dstGasForCall',
                internalType: 'uint256',
                type: 'uint256',
              },
              {
                name: 'dstNativeAmount',
                internalType: 'uint256',
                type: 'uint256',
              },
              { name: 'dstNativeAddr', internalType: 'bytes', type: 'bytes' },
            ],
          },
          { name: 'minAmountLD', internalType: 'uint256', type: 'uint256' },
        ],
      },
      {
        name: 'lzParams',
        internalType: 'struct IOmnichainMessenger.LzParams',
        type: 'tuple',
        components: [
          { name: 'options', internalType: 'bytes[]', type: 'bytes[]' },
          {
            name: 'zroPaymentAddress',
            internalType: 'address',
            type: 'address',
          },
        ],
      },
      { name: '', internalType: 'address payable', type: 'address' },
    ],
    name: 'finishVaultRebalancing',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'srcEid', internalType: 'uint16', type: 'uint16' },
      { name: 'srcAddress', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'forceResumeReceive',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'version', internalType: 'uint16', type: 'uint16' },
      { name: 'eid', internalType: 'uint16', type: 'uint16' },
      { name: '', internalType: 'address', type: 'address' },
      { name: 'configType', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getConfig',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'lzEndpoint',
    outputs: [
      {
        name: '',
        internalType: 'contract ILayerZeroEndpoint',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'srcEid', internalType: 'uint16', type: 'uint16' },
      { name: 'srcAddress', internalType: 'bytes', type: 'bytes' },
      { name: '', internalType: 'uint64', type: 'uint64' },
      { name: 'message', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'lzReceive',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint16', type: 'uint16' }],
    name: 'minGasAmountForChain',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'data', internalType: 'bytes', type: 'bytes' }],
    name: 'phutureOnConsumeCallbackV1',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'reserve', internalType: 'Currency', type: 'address' },
      { name: 'cbData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'phutureOnDepositCallbackV1',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'poolIds',
    outputs: [
      { name: 'src', internalType: 'uint128', type: 'uint128' },
      { name: 'dst', internalType: 'uint128', type: 'uint128' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'srcChainId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'boughtOrders',
        internalType: 'struct IOrderBook.BoughtOrder[]',
        type: 'tuple[]',
        components: [
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
          { name: 'buyCurrency', internalType: 'Currency', type: 'address' },
        ],
      },
      {
        name: 'boughtOrdersTotalAmount',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'currency', internalType: 'Currency', type: 'address' },
      { name: 'receivedAmount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'pushIncomingOrders',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct IIndex.RedemptionParams',
        type: 'tuple',
        components: [
          {
            name: 'config',
            internalType: 'struct IIndex.RedemptionConfig',
            type: 'tuple',
            components: [
              {
                name: 'shared',
                internalType: 'struct IIndex.Config',
                type: 'tuple',
                components: [
                  {
                    name: 'latestSnapshot',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'AUMDilutionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'useCustomAUMFee',
                    internalType: 'bool',
                    type: 'bool',
                  },
                  {
                    name: 'staticPriceOracle',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'metadata',
                    internalType: 'address',
                    type: 'address',
                  },
                ],
              },
              {
                name: 'fee',
                internalType: 'struct IIndex.FeeConfig',
                type: 'tuple',
                components: [
                  { name: 'BPs', internalType: 'uint16', type: 'uint16' },
                  {
                    name: 'useCustomCallback',
                    internalType: 'bool',
                    type: 'bool',
                  },
                ],
              },
              { name: 'forwarder', internalType: 'address', type: 'address' },
              {
                name: 'homeCurrencies',
                internalType: 'a160u96[]',
                type: 'uint256[]',
              },
            ],
          },
          { name: 'owner', internalType: 'address', type: 'address' },
          { name: 'shares', internalType: 'uint128', type: 'uint128' },
          { name: 'payload', internalType: 'bytes', type: 'bytes' },
        ],
      },
      {
        name: 'sendParams',
        internalType: 'struct IHomechainOmnichainMessenger.SendParams',
        type: 'tuple',
        components: [
          {
            name: 'config',
            internalType: 'struct IHomechainOmnichainMessenger.LzConfig',
            type: 'tuple',
            components: [
              { name: 'eIds', internalType: 'u16x15', type: 'uint256' },
              { name: 'minGas', internalType: 'uint256[]', type: 'uint256[]' },
            ],
          },
          {
            name: 'ranges',
            internalType: 'struct IHomechainOmnichainMessenger.Range[]',
            type: 'tuple[]',
            components: [
              { name: 'start', internalType: 'uint256', type: 'uint256' },
              { name: 'end', internalType: 'uint256', type: 'uint256' },
            ],
          },
          {
            name: 'trades',
            internalType: 'struct EscrowCallLib.Trade[][]',
            type: 'tuple[][]',
            components: [
              { name: 'skipRevert', internalType: 'bool', type: 'bool' },
              { name: 'currency', internalType: 'Currency', type: 'address' },
              {
                name: 'allowanceTarget',
                internalType: 'address',
                type: 'address',
              },
              { name: 'addr', internalType: 'address', type: 'address' },
              { name: 'value', internalType: 'uint256', type: 'uint256' },
              { name: 'data', internalType: 'bytes', type: 'bytes' },
            ],
          },
          {
            name: 'escrowCallback',
            internalType: 'struct EscrowCallLib.Target',
            type: 'tuple',
            components: [
              { name: 'skipRevert', internalType: 'bool', type: 'bool' },
              { name: 'addr', internalType: 'address', type: 'address' },
              { name: 'value', internalType: 'uint256', type: 'uint256' },
              { name: 'data', internalType: 'bytes', type: 'bytes' },
            ],
          },
          {
            name: 'batches',
            internalType: 'struct IHomechainOmnichainMessenger.Batches[]',
            type: 'tuple[]',
            components: [
              { name: 'escrow', internalType: 'address', type: 'address' },
              {
                name: 'data',
                internalType: 'struct IHomechainOmnichainMessenger.RemoteData[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'callbacks',
                    internalType: 'bytes[]',
                    type: 'bytes[]',
                  },
                  {
                    name: 'additionalGas',
                    internalType: 'uint256[]',
                    type: 'uint256[]',
                  },
                  {
                    name: 'airdropAmount',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                ],
              },
            ],
          },
          {
            name: 'zroPaymentAddress',
            internalType: 'address',
            type: 'address',
          },
          { name: 'packedRecipient', internalType: 'bytes', type: 'bytes' },
        ],
      },
    ],
    name: 'redeem',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'homeTrades',
        internalType: 'struct EscrowCallLib.Trade[]',
        type: 'tuple[]',
        components: [
          { name: 'skipRevert', internalType: 'bool', type: 'bool' },
          { name: 'currency', internalType: 'Currency', type: 'address' },
          { name: 'allowanceTarget', internalType: 'address', type: 'address' },
          { name: 'addr', internalType: 'address', type: 'address' },
          { name: 'value', internalType: 'uint256', type: 'uint256' },
          { name: 'data', internalType: 'bytes', type: 'bytes' },
        ],
      },
      {
        name: 'escrowCallback',
        internalType: 'struct EscrowCallLib.Target',
        type: 'tuple',
        components: [
          { name: 'skipRevert', internalType: 'bool', type: 'bool' },
          { name: 'addr', internalType: 'address', type: 'address' },
          { name: 'value', internalType: 'uint256', type: 'uint256' },
          { name: 'data', internalType: 'bytes', type: 'bytes' },
        ],
      },
      {
        name: 'retries',
        internalType: 'struct IHomechainOmnichainMessenger.Retry[]',
        type: 'tuple[]',
        components: [
          { name: 'eid', internalType: 'uint16', type: 'uint16' },
          { name: 'options', internalType: 'bytes[]', type: 'bytes[]' },
          { name: 'callbacks', internalType: 'bytes[]', type: 'bytes[]' },
        ],
      },
      {
        name: 'refundAddress',
        internalType: 'address payable',
        type: 'address',
      },
      { name: 'zroPaymentAddress', internalType: 'address', type: 'address' },
    ],
    name: 'retryRedeem',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_infos',
        internalType: 'struct IOmnichainMessenger.BridgingInfo[]',
        type: 'tuple[]',
        components: [
          { name: 'finalDstChainId', internalType: 'uint256', type: 'uint256' },
          { name: 'localCurrency', internalType: 'Currency', type: 'address' },
        ],
      },
    ],
    name: 'setBridgingInfo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'version', internalType: 'uint16', type: 'uint16' },
      { name: 'eid', internalType: 'uint16', type: 'uint16' },
      { name: 'configType', internalType: 'uint256', type: 'uint256' },
      { name: 'config', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'setConfig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_escrowDeployer', internalType: 'address', type: 'address' }],
    name: 'setEscrowDeployer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'config',
        internalType: 'struct IHomechainOmnichainMessenger.LzConfig',
        type: 'tuple',
        components: [
          { name: 'eIds', internalType: 'u16x15', type: 'uint256' },
          { name: 'minGas', internalType: 'uint256[]', type: 'uint256[]' },
        ],
      },
    ],
    name: 'setLayerZeroConfig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_orderBook', internalType: 'address', type: 'address' }],
    name: 'setOrderBook',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'version', internalType: 'uint16', type: 'uint16' }],
    name: 'setReceiveVersion',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'version', internalType: 'uint16', type: 'uint16' }],
    name: 'setSendVersion',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'remoteChainId', internalType: 'uint256', type: 'uint256' },
      { name: 'remoteEid', internalType: 'uint16', type: 'uint16' },
      { name: 'minGasAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'path', internalType: 'bytes', type: 'bytes' },
      {
        name: '_poolIds',
        internalType: 'struct IBlockingApp.PoolIds',
        type: 'tuple',
        components: [
          { name: 'src', internalType: 'uint128', type: 'uint128' },
          { name: 'dst', internalType: 'uint128', type: 'uint128' },
        ],
      },
    ],
    name: 'setTrustedRemote',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'srcEid', internalType: 'uint16', type: 'uint16' },
      { name: 'srcAddress', internalType: 'bytes', type: 'bytes' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'amountLD', internalType: 'uint256', type: 'uint256' },
      { name: 'payload', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'sgReceive',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint16', type: 'uint16' }],
    name: 'trustedRemotes',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'currency', internalType: 'Currency', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'withdrawCurrency',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'chainId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrdersHashClear',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'orders',
        internalType: 'struct IOrderBook.BoughtOrder[]',
        type: 'tuple[]',
        components: [
          { name: 'amount', internalType: 'uint256', type: 'uint256' },
          { name: 'buyCurrency', internalType: 'Currency', type: 'address' },
        ],
        indexed: false,
      },
      {
        name: 'totalBought',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OutgoingOrders',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'config',
        internalType: 'struct IHomechainOmnichainMessenger.LzConfig',
        type: 'tuple',
        components: [
          { name: 'eIds', internalType: 'u16x15', type: 'uint256' },
          { name: 'minGas', internalType: 'uint256[]', type: 'uint256[]' },
        ],
        indexed: false,
      },
    ],
    name: 'SetLZConfig',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'remoteEid',
        internalType: 'uint16',
        type: 'uint16',
        indexed: false,
      },
      { name: 'path', internalType: 'bytes', type: 'bytes', indexed: false },
      {
        name: 'poolIds',
        internalType: 'struct IBlockingApp.PoolIds',
        type: 'tuple',
        components: [
          { name: 'src', internalType: 'uint128', type: 'uint128' },
          { name: 'dst', internalType: 'uint128', type: 'uint128' },
        ],
        indexed: false,
      },
    ],
    name: 'TrustedRemoteSet',
  },
  {
    type: 'error',
    inputs: [{ name: 'dstChainId', internalType: 'uint256', type: 'uint256' }],
    name: 'BridgingCurrencyNotFound',
  },
  { type: 'error', inputs: [], name: 'ConfigHash' },
  { type: 'error', inputs: [], name: 'ERC20TransferFailed' },
  { type: 'error', inputs: [], name: 'Forbidden' },
  { type: 'error', inputs: [], name: 'Invalid' },
  { type: 'error', inputs: [], name: 'InvalidBatches' },
  {
    type: 'error',
    inputs: [
      { name: '_size', internalType: 'uint256', type: 'uint256' },
      { name: '_start', internalType: 'uint256', type: 'uint256' },
      { name: '_end', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidCodeAtRange',
  },
  { type: 'error', inputs: [], name: 'InvalidOptions' },
  { type: 'error', inputs: [], name: 'InvalidPermit' },
  { type: 'error', inputs: [], name: 'InvalidRanges' },
  { type: 'error', inputs: [], name: 'InvalidTrade' },
  { type: 'error', inputs: [], name: 'NativeTransferFailed' },
  { type: 'error', inputs: [], name: 'OnlyEndpoint' },
  { type: 'error', inputs: [], name: 'OrderHashMismatch' },
  {
    type: 'error',
    inputs: [{ name: 'eid', internalType: 'uint16', type: 'uint16' }],
    name: 'PathNotFound',
  },
  { type: 'error', inputs: [], name: 'PermitFailed' },
  { type: 'error', inputs: [], name: 'QueryFailed' },
  { type: 'error', inputs: [], name: 'RefundFailed' },
  { type: 'error', inputs: [], name: 'Set' },
  { type: 'error', inputs: [], name: 'TradeFailed' },
  { type: 'error', inputs: [], name: 'WriteError' },
  { type: 'error', inputs: [], name: 'ZRONotSupported' },
] as const
